import React from "react";
import { useApp } from "@/context/AppContext";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerDescription,
} from "@/components/ui/drawer";
import { Check } from "lucide-react";

export default function UserPickerDrawer({ open, onOpenChange }) {
  const { members, activeUser, setActiveUserId } = useApp();

  const pick = (id) => {
    setActiveUserId(id);
    onOpenChange(false);
  };

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="bg-[#FAF8F3] max-h-[85vh]">
        <DrawerHeader>
          <DrawerTitle className="font-display text-2xl text-[#0A3D62]">
            Who's fishing?
          </DrawerTitle>
          <DrawerDescription className="text-[#556B7D]">
            Tap a name — catches you log will be credited to them.
          </DrawerDescription>
        </DrawerHeader>
        <div className="px-5 pb-6 space-y-2 overflow-y-auto" data-testid="user-picker-list">
          {members.map((m) => {
            const active = activeUser?.id === m.id;
            return (
              <button
                key={m.id}
                onClick={() => pick(m.id)}
                data-testid={`user-pick-${m.id}`}
                className={`w-full flex items-center gap-4 p-3 rounded-2xl active:scale-[0.99] transition ${
                  active
                    ? "bg-[#E8A838]/15 border-2 border-[#E8A838]"
                    : "bg-white border border-[#0A3D62]/10"
                }`}
              >
                <div
                  className="w-14 h-14 rounded-full flex items-center justify-center text-3xl"
                  style={{ background: m.color + "33" }}
                >
                  {m.emoji}
                </div>
                <div className="flex-1 text-left">
                  <div className="font-display text-xl font-black text-[#0A3D62]">{m.name}</div>
                </div>
                {active && (
                  <div className="w-9 h-9 rounded-full bg-[#E8A838] text-[#1A2A35] flex items-center justify-center">
                    <Check className="w-5 h-5" strokeWidth={3} />
                  </div>
                )}
              </button>
            );
          })}
        </div>
      </DrawerContent>
    </Drawer>
  );
}
